import * as React from 'react';
import { Spinner, SpinnerSize } from '@fluentui/react';
import PropTypes from 'prop-types';
import './Progress.scss';

/**
 * Component for displaying spinner or skeletons
 * @param {object} progress
 * @param {*} progress.child (optional) Component to be rendered
 * @return {*} html of spinner/skelton
 */
const Progress = ({ child }) => {
  if (child) {
    return (
      <>
        { child }
      </>
    );
  } else {
    return (
      <div className='progress'>
        <Spinner size={SpinnerSize.large} />
      </div>
    );
  }
};

export default Progress;

Progress.propTypes = {
  child: PropTypes.any,
};
